(function () {
  "use strict";

  // Configuration
  const PROXY_API_BASE =
    "https://aeternum-delhivery-proxy-psi.vercel.app/api/pincode/";
  let isChecking = false;

  // Fallback pincode data for common cities (when API fails)
  const FALLBACK_PINCODE_DATA = {
    110001: {
      area: "Connaught Place",
      district: "New Delhi",
      state: "Delhi",
      cod: true,
    },
    110002: {
      area: "Darya Ganj",
      district: "New Delhi",
      state: "Delhi",
      cod: true,
    },
    110003: {
      area: "Civil Lines",
      district: "New Delhi",
      state: "Delhi",
      cod: true,
    },
    400001: {
      area: "Fort",
      district: "Mumbai",
      state: "Maharashtra",
      cod: true,
    },
    400002: {
      area: "Kalbadevi",
      district: "Mumbai",
      state: "Maharashtra",
      cod: true,
    },
    400003: {
      area: "Masjid Bunder",
      district: "Mumbai",
      state: "Maharashtra",
      cod: true,
    },
    560001: {
      area: "Bangalore GPO",
      district: "Bangalore Urban",
      state: "Karnataka",
      cod: true,
    },
    560002: {
      area: "Chickpet",
      district: "Bangalore Urban",
      state: "Karnataka",
      cod: true,
    },
    560003: {
      area: "Dravidanagar",
      district: "Bangalore Urban",
      state: "Karnataka",
      cod: true,
    },
    600001: {
      area: "Parrys",
      district: "Chennai",
      state: "Tamil Nadu",
      cod: true,
    },
    600002: {
      area: "Anna Salai",
      district: "Chennai",
      state: "Tamil Nadu",
      cod: true,
    },
    600003: {
      area: "Triplicane",
      district: "Chennai",
      state: "Tamil Nadu",
      cod: true,
    },
    700001: {
      area: "Dalhousie Square",
      district: "Kolkata",
      state: "West Bengal",
      cod: true,
    },
    700002: {
      area: "Bow Barracks",
      district: "Kolkata",
      state: "West Bengal",
      cod: true,
    },
    700003: {
      area: "Phears Lane",
      district: "Kolkata",
      state: "West Bengal",
      cod: true,
    },
    500001: {
      area: "Abids",
      district: "Hyderabad",
      state: "Telangana",
      cod: true,
    },
    500002: {
      area: "Troop Bazar",
      district: "Hyderabad",
      state: "Telangana",
      cod: true,
    },
    500003: {
      area: "Kachiguda",
      district: "Hyderabad",
      state: "Telangana",
      cod: true,
    },
    411001: {
      area: "Pune Cantonment",
      district: "Pune",
      state: "Maharashtra",
      cod: true,
    },
    411002: {
      area: "Bund Garden",
      district: "Pune",
      state: "Maharashtra",
      cod: true,
    },
    411003: {
      area: "Deccan Gymkhana",
      district: "Pune",
      state: "Maharashtra",
      cod: true,
    },
    380001: {
      area: "Ellis Bridge",
      district: "Ahmedabad",
      state: "Gujarat",
      cod: true,
    },
    380002: {
      area: "Navrangpura",
      district: "Ahmedabad",
      state: "Gujarat",
      cod: true,
    },
    380003: {
      area: "Maninagar",
      district: "Ahmedabad",
      state: "Gujarat",
      cod: true,
    },
    302001: {
      area: "Jaipur City",
      district: "Jaipur",
      state: "Rajasthan",
      cod: true,
    },
    302002: {
      area: "Bani Park",
      district: "Jaipur",
      state: "Rajasthan",
      cod: true,
    },
    302003: {
      area: "Civil Lines",
      district: "Jaipur",
      state: "Rajasthan",
      cod: true,
    },
    160001: {
      area: "Sector 1",
      district: "Chandigarh",
      state: "Chandigarh",
      cod: true,
    },
    160002: {
      area: "Sector 2",
      district: "Chandigarh",
      state: "Chandigarh",
      cod: true,
    },
    682001: {
      area: "Ernakulam South",
      district: "Ernakulam",
      state: "Kerala",
      cod: true,
    },
    682002: {
      area: "Ernakulam North",
      district: "Ernakulam",
      state: "Kerala",
      cod: true,
    },
    695001: {
      area: "Thiruvananthapuram",
      district: "Thiruvananthapuram",
      state: "Kerala",
      cod: true,
    },
    695002: {
      area: "Vazhuthacaud",
      district: "Thiruvananthapuram",
      state: "Kerala",
      cod: true,
    },
  };

  // Initialize when DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initPincodeChecker);
  } else {
    initPincodeChecker();
  }

  function initPincodeChecker() {
    const pincodeInput = document.getElementById("pincodeInput");
    const checkBtn = document.getElementById("checkPincodeBtn");

    if (!pincodeInput || !checkBtn) return;

    // Event listeners
    checkBtn.addEventListener("click", handlePincodeCheck);
    pincodeInput.addEventListener("keypress", function (e) {
      if (e.key === "Enter") {
        handlePincodeCheck();
      }
    });

    // Input validation
    pincodeInput.addEventListener("input", function (e) {
      // Only allow numbers
      e.target.value = e.target.value.replace(/[^0-9]/g, "");

      // Limit to 6 digits
      if (e.target.value.length > 6) {
        e.target.value = e.target.value.slice(0, 6);
      }
    });
  }

  async function handlePincodeCheck() {
    const pincodeInput = document.getElementById("pincodeInput");
    const pincode = pincodeInput.value.trim();

    if (!validatePincode(pincode)) {
      showResult("invalid");
      return;
    }

    if (isChecking) return;

    try {
      setLoadingState(true);
      const result = await checkPincodeAvailability(pincode);

      if (result.success) {
        showResult("success", result.data);
      } else if (result.expanding) {
        showResult("expanding", result.data);
      } else {
        showResult("error");
      }
    } catch (error) {
      console.error("Pincode check error:", error);
      showResult("error");
    } finally {
      setLoadingState(false);
    }
  }

  function validatePincode(pincode) {
    return /^[0-9]{6}$/.test(pincode);
  }

  async function checkPincodeAvailability(pincode) {
    try {
      // First try the proxy API
      const apiResult = await tryProxyAPI(pincode);
      if (apiResult.success) {
        return apiResult;
      }

      // If API fails, check fallback data
      if (FALLBACK_PINCODE_DATA[pincode]) {
        const fallbackData = FALLBACK_PINCODE_DATA[pincode];
        return {
          success: true,
          data: {
            pincode: pincode,
            area: fallbackData.area,
            district: fallbackData.district,
            state: fallbackData.state,
            cod: fallbackData.cod,
            deliverable: true,
            source: "fallback",
          },
        };
      }

      // If not in fallback, show expanding network message
      return {
        success: false,
        expanding: true,
        data: { pincode: pincode },
      };
    } catch (error) {
      console.error("Pincode availability check failed:", error);

      // Check fallback data on any error
      if (FALLBACK_PINCODE_DATA[pincode]) {
        const fallbackData = FALLBACK_PINCODE_DATA[pincode];
        return {
          success: true,
          data: {
            pincode: pincode,
            area: fallbackData.area,
            district: fallbackData.district,
            state: fallbackData.state,
            cod: fallbackData.cod,
            deliverable: true,
            source: "fallback",
          },
        };
      }

      return { success: false };
    }
  }

  async function tryProxyAPI(pincode) {
    try {
      const response = await fetch(`${PROXY_API_BASE}${pincode}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      // Handle the response structure from your proxy server
      if (data.success && data.data && data.data.deliverable) {
        return {
          success: true,
          data: {
            pincode: data.data.pincode,
            area: data.data.area || "Area information not available",
            district: data.data.district,
            state: data.data.state,
            cod: data.data.cod,
            deliverable: data.data.deliverable,
            source: "proxy_api",
          },
        };
      } else if (data.success === false) {
        // Handle case where proxy returns success: false
        return { success: false };
      } else {
        // Handle unexpected response format
        console.warn("Unexpected API response format:", data);
        return { success: false };
      }
    } catch (error) {
      console.error("Proxy API Error:", error);
      throw error;
    }
  }

  function setLoadingState(loading) {
    isChecking = loading;
    const checkBtn = document.getElementById("checkPincodeBtn");
    const btnText = checkBtn.querySelector(".btn-text");
    const btnLoading = checkBtn.querySelector(".btn-loading");

    if (checkBtn && btnText && btnLoading) {
      checkBtn.disabled = loading;
      btnText.style.display = loading ? "none" : "inline";
      btnLoading.style.display = loading ? "inline" : "none";
    }
  }

  function showResult(type, data = null) {
    const resultsContainer = document.getElementById("pincodeResults");
    const successResult = document.getElementById("successResult");
    const errorResult = document.getElementById("errorResult");
    const invalidResult = document.getElementById("invalidResult");
    const expandingResult = document.getElementById("expandingResult");

    if (!resultsContainer) return;

    // Hide all results first
    if (successResult) successResult.style.display = "none";
    if (errorResult) errorResult.style.display = "none";
    if (invalidResult) invalidResult.style.display = "none";
    if (expandingResult) expandingResult.style.display = "none";

    // Show the appropriate result
    if (type === "success" && data) {
      populateSuccessResult(data);
      if (successResult) successResult.style.display = "flex";
    } else if (type === "error") {
      if (errorResult) errorResult.style.display = "flex";
    } else if (type === "invalid") {
      if (invalidResult) invalidResult.style.display = "flex";
    } else if (type === "expanding") {
      if (expandingResult) expandingResult.style.display = "flex";
    }

    resultsContainer.style.display = "block";
    resultsContainer.scrollIntoView({ behavior: "smooth", block: "nearest" });
  }

  function populateSuccessResult(data) {
    const deliveryArea = document.getElementById("deliveryArea");
    const deliveryDistrict = document.getElementById("deliveryDistrict");
    const deliveryState = document.getElementById("deliveryState");
    const codInfo = document.getElementById("codInfo");

    if (deliveryArea) deliveryArea.textContent = data.area || "N/A";
    if (deliveryDistrict) deliveryDistrict.textContent = data.district || "N/A";
    if (deliveryState) deliveryState.textContent = data.state || "N/A";

    // Show COD info if available
    if (codInfo) {
      if (data.cod) {
        codInfo.style.display = "flex";
      } else {
        codInfo.style.display = "none";
      }
    }
  }

  // Global function for quick pincode checking
  window.checkQuickPincode = function (pincode) {
    const pincodeInput = document.getElementById("pincodeInput");
    if (pincodeInput) {
      pincodeInput.value = pincode;
      handlePincodeCheck();
    }
  };

  // Global function for contact support
  window.contactSupport = function () {
    // Implement contact support functionality
    // This could open a chat widget, redirect to contact page, etc.
    if (window.location.pathname.includes("/pages/contact")) {
      window.location.href = "/pages/contact";
    } else {
      alert(
        "Please contact our support team for assistance with delivery to your area."
      );
    }
  };
})();
